export const WES_COACH_MODE_ID = 'WES_CHECKOUT_V2';
export const WES_ASK_COURSERA_HEADER_SLOT_ID = 'wes-ask-coursera-header-slot';
export const WES_CHATBOT_DIALOG_ID = 'wes-chatbot-dialog';

export type AdditionalContextItem = {
  contextKey: string;
  contextValue: string;
};

export type ContextConfigType = {
  config: {
    coachModeId: string;
    coachActionId: string;
  };
  additionalContext: AdditionalContextItem[];
  courseraContext: Record<string, unknown>;
};

export const CONTEXT_CONFIG: ContextConfigType = {
  config: {
    coachModeId: WES_COACH_MODE_ID,
    coachActionId: 'ASSISTANT_PUBLIC',
  },
  additionalContext: [],
  courseraContext: {},
};

export const getActiveCoachModeId = () => WES_COACH_MODE_ID;
